import { Injectable } from '@angular/core'
import { from, Observable } from 'rxjs'
import { ViewsApiService } from 'src/app/builder-services/api/views.api.service'

@Injectable({
  providedIn: 'root'
})
export class VersionsService {
  constructor(
    private viewsApi: ViewsApiService,
  ) {}

  setVersion = (project_id: any, version_name: string): Observable<{ success: boolean }> => {
    return from(this.viewsApi.setVersion(String(project_id), version_name))
  }

  getVersions = (project_id: any): Observable<Record<string, boolean>> => {
    return from(this.viewsApi.getVersions(String(project_id)))
  }

  applyVersion = (project_id: any, version_name: string): Observable<void> => {
    return from(this.viewsApi.applyVersion(String(project_id), version_name))
  }

  deleteVersion = (project_id: any, version_name: string): Observable<void> => {
    return from(this.viewsApi.deleteVersion(String(project_id), version_name))
  }
}
